export enum CountryCode {
  AT = 'AT',
  AU = 'AU',
  AX = 'AX',
  BR = 'BR',
  BE = 'BE',
  BG = 'BG',
  CA = 'CA',
  CI = 'CI',
  CH = 'CH',
  CL = 'CL',
  CN = 'CN',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DK = 'DK',
  EE = 'EE',
  ES = 'ES',
  FI = 'FI',
  FR = 'FR',
  GB = 'GB',
  GR = 'GR',
  HK = 'HK',
  HR = 'HR',
  HU = 'HU',
  IE = 'IE',
  IL = 'IL',
  IN = 'IN',
  IS = 'IS',
  IT = 'IT',
  JP = 'JP',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  MT = 'MT',
  NL = 'NL',
  NO = 'NO',
  NZ = 'NZ',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  RS = 'RS',
  SE = 'SE',
  SI = 'SI',
  SK = 'SK',
  SG = 'SG',
  TR = 'TR',
  TH = 'TH',
  US = 'US',
  TG = 'TG',
  SL = 'SL',
  HM = 'HM',
  SR = 'SR',
  LR = 'LR',
  MQ = 'MQ',
  AO = 'AO',
  KE = 'KE',
  MH = 'MH',
  BZ = 'BZ',
  RE = 'RE',
  MW = 'MW',
  TO = 'TO',
  CW = 'CW',
  TF = 'TF',
  LI = 'LI',
  MO = 'MO',
  CD = 'CD',
  ZA = 'ZA',
  KW = 'KW',
  EG = 'EG',
  GD = 'GD',
  ME = 'ME',
  MD = 'MD',
  PR = 'PR',
  DZ = 'DZ',
  NR = 'NR',
  ZM = 'ZM',
  GS = 'GS',
  ER = 'ER',
  BM = 'BM',
  SD = 'SD',
  SV = 'SV',
  BO = 'BO',
  LA = 'LA',
  LY = 'LY',
  JO = 'JO',
  BF = 'BF',
  HN = 'HN',
  NA = 'NA',
  SS = 'SS',
  UZ = 'UZ',
  ID = 'ID',
  GP = 'GP',
  IO = 'IO',
  UY = 'UY',
  CM = 'CM',
  SJ = 'SJ',
  BB = 'BB',
  KI = 'KI',
  AM = 'AM',
  LS = 'LS',
  MU = 'MU',
  AZ = 'AZ',
  PN = 'PN',
  BH = 'BH',
  GU = 'GU',
  CC = 'CC',
  BD = 'BD',
  GM = 'GM',
  VC = 'VC',
  TK = 'TK',
  TL = 'TL',
  NE = 'NE',
  KM = 'KM',
  SC = 'SC',
  PE = 'PE',
  TZ = 'TZ',
  MZ = 'MZ',
  MK = 'MK',
  TW = 'TW',
  AQ = 'AQ',
  BA = 'BA',
  NU = 'NU',
  BJ = 'BJ',
  NP = 'NP',
  MN = 'MN',
  AR = 'AR',
  KY = 'KY',
  GH = 'GH',
  BS = 'BS',
  DM = 'DM',
  IQ = 'IQ',
  MP = 'MP',
  KG = 'KG',
  TJ = 'TJ',
  FJ = 'FJ',
  BW = 'BW',
  AG = 'AG',
  TM = 'TM',
  CG = 'CG',
  SX = 'SX',
  SN = 'SN',
  MA = 'MA',
  BL = 'BL',
  AD = 'AD',
  UG = 'UG',
  GE = 'GE',
  SA = 'SA',
  VA = 'VA',
  CV = 'CV',
  AI = 'AI',
  MS = 'MS',
  AL = 'AL',
  TC = 'TC',
  BT = 'BT',
  LK = 'LK',
  TT = 'TT',
  GG = 'GG',
  MF = 'MF',
  PG = 'PG',
  HT = 'HT',
  PM = 'PM',
  YT = 'YT',
  WS = 'WS',
  CR = 'CR',
  GQ = 'GQ',
  DO = 'DO',
  EH = 'EH',
  MG = 'MG',
  TV = 'TV',
  MV = 'MV',
  UM = 'UM',
  VN = 'VN',
  NG = 'NG',
  BQ = 'BQ',
  FK = 'FK',
  MX = 'MX',
  ST = 'ST',
  LB = 'LB',
  SO = 'SO',
  BV = 'BV',
  SZ = 'SZ',
  GI = 'GI',
  NI = 'NI',
  PA = 'PA',
  LC = 'LC',
  VU = 'VU',
  FO = 'FO',
  CF = 'CF',
  JM = 'JM',
  AW = 'AW',
  NF = 'NF',
  YE = 'YE',
  CO = 'CO',
  PF = 'PF',
  VG = 'VG',
  PH = 'PH',
  KZ = 'KZ',
  KN = 'KN',
  TN = 'TN',
  ZW = 'ZW',
  FM = 'FM',
  PY = 'PY',
  KH = 'KH',
  GF = 'GF',
  BI = 'BI',
  GA = 'GA',
  DJ = 'DJ',
  UA = 'UA',
  CK = 'CK',
  IM = 'IM',
  JE = 'JE',
  TD = 'TD',
  GT = 'GT',
  GL = 'GL',
  MY = 'MY',
  GW = 'GW',
  OM = 'OM',
  GN = 'GN',
  PW = 'PW',
  RW = 'RW',
  SH = 'SH',
  MC = 'MC',
  SM = 'SM',
  ET = 'ET',
  SB = 'SB',
  KR = 'KR',
  PK = 'PK',
  WF = 'WF',
  EC = 'EC',
  NC = 'NC',
  VI = 'VI',
  QA = 'QA',
  GY = 'GY',
  CX = 'CX',
  MR = 'MR',
  BN = 'BN',
  AE = 'AE',
  AS = 'AS',
  ML = 'ML',
}

export const CountryCodeValues = Object.values(CountryCode);
